import { Api } from '../api';
import { resources } from '../endpoints';
import type { ResourceEntity } from './models';
import type { IFile } from '../file';

export class ResourcesApi extends Api {
  static getRepository = (signal?: AbortSignal) => this.get<ResourceEntity[]>({ url: resources.getRepository(), signal });

  static downloadFile = (id: string, signal?: AbortSignal) =>
    this.get<IFile>({ url: resources.download(id), headers: { Accept: 'application/pdf' }, signal });
}
